import appClient from '../../common/services/AppClient';
import { EnvironmentVariable } from '../types';
import { endpoints } from '../../../config';

export default class EnvironmentVariablesService {
    async getAllEnvironmentVariables(): Promise<EnvironmentVariable[]> {
        const url = `${endpoints.manageUrl}environment_variables`;
        const result = await appClient.get<EnvironmentVariable[]>(url);
        return result.unwrapOr([]);
    }

    async getEnvironmentVariableValues(
        projectId: string,
        envVarIds: string[]
    ): Promise<{ [id: string]: string | null }> {
        let idsQuery: string = '?varIds=';

        idsQuery += envVarIds.join('&varIds=');

        const url = endpoints.manageUrl + `projects/${projectId}/iota/applications/environment-variables${idsQuery}`;
        const resp = await appClient.get<{ [id: string]: string | null }>(url);

        return resp.unwrapOr({});
    }
}
